import { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone } from "lucide-react";
import { API } from "../../lib/api";
import { useAuthed } from "../../lib/adminApi";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { toast } from "sonner";

export default function WebsiteMessages() {
  const call = useAuthed();
  const [t, setT] = useState(null);

  useEffect(() => { axios.get(`${API}/menu-status`).then((r) => setT(r.data)).catch(() => toast.error("Could not load settings")); }, []);

  const save = async (next = t, prev = t) => {
    try {
      const r = await call("put", "/admin/menu-settings", {
        banner_text: next.banner_text.trim(), unavailable_label: next.unavailable_label.trim(), show_banner: next.show_banner,
      });
      setT(r.data);
      toast.success("Website settings saved");
    } catch (e) {
      setT(prev);
      toast.error(e.response?.status === 422 ? "Both messages are required" : "Could not save, please try again");
    }
  };

  if (!t) return <div className="text-gray-500">Loading…</div>;
  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h1 className="font-display font-extrabold text-xl sm:text-2xl flex items-center gap-2"><Megaphone size={22} className="text-[#CC1A00]" /> Website messages</h1>
        <p className="text-sm text-gray-500 mt-1">The full standard menu is always shown and can be ordered. To stop orders for a dish, switch on "Not available" on that dish in the Menu tab. To remove it from the website completely, switch off "Show on website".</p>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 p-4 space-y-3" data-testid="menu-texts">
        <label className="flex items-center justify-between gap-3 text-sm font-semibold">
          Show the announcement banner on the website
          <Switch checked={t.show_banner} onCheckedChange={(v) => { const n = { ...t, show_banner: v }; const p = t; setT(n); save(n, p); }} data-testid="show-banner-switch" />
        </label>
        <div>
          <div className="text-xs font-semibold mb-1">Banner text</div>
          <Input value={t.banner_text} onChange={(e) => setT({ ...t, banner_text: e.target.value })} data-testid="banner-text-input" />
        </div>
        <div>
          <div className="text-xs font-semibold mb-1">Label on dishes you mark as not available</div>
          <Input maxLength={30} value={t.unavailable_label} onChange={(e) => setT({ ...t, unavailable_label: e.target.value })} data-testid="unavailable-label-input" />
        </div>
        <Button onClick={() => save(t, t)} className="mlobox-gradient text-white rounded-full" data-testid="save-menu-texts">Save messages</Button>
      </div>
    </div>
  );
}
